// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"d5973b72","262":"d265703e","347":"bb4eed65","444":"72e15633","739":"97ef1c0c","741":"de7ac5b3","857":"f8568af7","919":"3a0b9382"}[chunkId] + ".chunk.js";
};